import React from 'react';
import './ConfirmDialog.css';

/**
 * ConfirmDialog — replaces window.confirm() with a styled modal.
 * Props: isOpen, title, message, confirmLabel, danger, onConfirm, onCancel
 */
export default function ConfirmDialog({
  isOpen,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  danger = false,
  onConfirm,
  onCancel,
}) {
  if (!isOpen) return null;

  return (
    <div className="confirm-overlay" role="dialog" aria-modal="true" aria-labelledby="confirm-title">
      <div className="confirm-box">
        <h3 id="confirm-title" className="confirm-title">{title}</h3>
        {message && <p className="confirm-message">{message}</p>}
        <div className="confirm-actions">
          <button className="confirm-btn confirm-cancel" onClick={onCancel}>Cancel</button>
          <button
            className={`confirm-btn ${danger ? 'confirm-danger' : 'confirm-ok'}`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
